module.exports = __webpack_public_path__ + "img/74.5bcd87bd.jpg";